export default __webpack_public_path__ + "guide919133.png";